import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/feature/country/feature.country.mutation.gql"
import type {
  FeatureCountryMutation,
  FeatureCountryMutationVariables,
} from "@/v2-backoffice-client/feature/country/__types__/feature.country.mutation"

type Options = MutationHookOptions<
  FeatureCountryMutation,
  FeatureCountryMutationVariables
>

export function useFeatureCountryMutation(options?: Options) {
  return useMutation<FeatureCountryMutation, FeatureCountryMutationVariables>(
    mutation,
    options,
  )
}
